import { PageFilterFacetFragment } from '../../generated/types';
import { MARKDOWN_PERCENTAGE_BUCKET_KEYS, getBucketWidth } from './markdownPercentageBuckets';

const MINIMUM_BUCKET_COUNT = 10;
const MINIMUM_BUCKET_TOTAL = 2;

export const getMarkdownPercentageItems = (
  markdownPercentages: (PageFilterFacetFragment | null)[],
  selectedParams: string[]
) => {
  if (!markdownPercentages) return null;

  const counts = markdownPercentages.reduce(
    (accumulatedCounts, tag) =>
      tag ? { ...accumulatedCounts, [tag.name]: tag.totalItems } : accumulatedCounts,
    {} as { [rawValue: string]: number }
  );

  const sortedKeys = [...MARKDOWN_PERCENTAGE_BUCKET_KEYS].sort((previous, next) => previous - next);

  const buckets = sortedKeys.map(key => {
    const isLast = sortedKeys.indexOf(key) === sortedKeys.length - 1;
    const width = getBucketWidth(key, sortedKeys);

    const matchingRawValues = Object.keys(counts).filter(rawValue => {
      const value = Number(rawValue);
      return isLast ? value >= key : value >= key && value < key + width;
    });

    const bucketCount = matchingRawValues.reduce((total, rawValue) => total + counts[rawValue], 0);

    return { key, label: `${key}%${isLast ? '+' : ''} Off`, value: matchingRawValues, bucketCount };
  });

  const populatedBuckets = buckets.filter(bucket => bucket.bucketCount >= MINIMUM_BUCKET_COUNT);

  if (populatedBuckets.length < MINIMUM_BUCKET_TOTAL) return undefined;

  return [
    {
      key: 'all',
      label: 'All Sale',
      value: [] as string[],
      isSelected: selectedParams.length === 0
    },
    ...populatedBuckets.map(bucket => ({
      key: bucket.key,
      label: bucket.label,
      value: [String(bucket.key)],
      isSelected: selectedParams.includes(String(bucket.key))
    }))
  ];
};
